<template>
  <div>
    <section
      class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white t-mb-5"
    >
      <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
        <h3 class="t-text-xl t-font-bold">
          Fleets
          <span class="t-float-right">
            <i v-if="loading && !error" class="fa fa-spinner fa-spin"></i>
            <button
              v-else
              @click="showForm()"
              class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-text-sm t-py-2 t-px-4 t-rounded"
            >
              Create Fleet
            </button>
          </span>
        </h3>
      </div>

      <div
        v-if="error"
        class="t-bg-yellow-100 t-border t-border-yellow-400 t-text-yellow-700 t-px-4 t-py-2 t-my-3 t-rounded t-relative"
      >
        {{ error }}
      </div>
      <div
        v-if="!loading && fleets.length == 0"
        class="t-bg-blue-100 t-border t-border-blue-400 t-text-blue-700 t-px-4 t-py-2 t-my-3 t-rounded t-relative"
      >
        You don't currently have any fleets.
      </div>

      <table
        v-if="fleets.length > 0"
        class="t-w-full t-text-md bg-white t-rounded t-mb-4"
      >
        <tr
          v-for="(fleet, index) in fleets"
          :key="fleet.id"
          class="t-border-b hover:t-bg-gray-300 t-bg-gray-100"
        >
          <td class="t-align-top t-p-3 t-px-5">
            <span
              class="t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-text-sm t-py-2 t-px-4 t-rounded"
              >{{ fleet.trucks.length }} trucks <i class="fa fa-truck"></i
            ></span>
          </td>
          <td class="t-align-top t-p-3 t-px-5">
            <button
              @click="showForm(index)"
              type="button"
              class="t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-text-sm t-py-2 t-px-4 t-rounded"
            >
              Edit
            </button>
            <i
              v-if="deletingFleet == fleet.id"
              class="fa fa-spinner fa-spin"
            ></i>
            <button
              v-else
              @click="deleteFleet(index)"
              type="button"
              class="t-bg-red-500 hover:t-bg-red-700 t-text-white t-text-sm t-py-2 t-px-4 t-rounded"
            >
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </table>

      <fleets-form
        v-if="formShowing"
        :fleet="editingFleet"
        :showing="formShowing"
        @cancelled="hideForm()"
        @submitted="formSubmitted"
        @error="createError()"
      ></fleets-form>
    </section>
  </div>
</template>

<script>
import FleetsForm from "./FleetsForm";

export default {
  name: "fleets",
  components: {
    FleetsForm
  },

  props: [],

  data() {
    return {
      deletingFleet: null,
      toggleLoading: null,
      formShowing: false,
      loading: true,
      error: null,
      fleets: [],
      editingFleet: null
    };
  },

  mounted() {
    this.loadFleets();
  },

  methods: {
    loadFleets() {
      this.loading = true;

      this.toggleLoading = null;

      this.fleets = [];

      api
        .get("carrier/gps/fleets?trucks")
        .then(response => {
          this.fleets = response.data.data;
          this.loading = false;
        })
        .catch(error => {
          this.error =
            "There was a problem loading your fleets, we've been notified and will look into it.";
        });
    },

    deleteFleet(fleetIndex) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deletingFleet = this.fleets[fleetIndex].id;

          api
            .delete("carrier/gps/fleets/" + this.fleets[fleetIndex].id)
            .then(response => {
              this.deletingFleet = null;
              this.fleets.splice(fleetIndex, 1);
            })
            .catch(error => {
              this.deletingFleet = null;
              this.$swal({
                title: "Error!",
                text:
                  "There was an error deleting your fleet, please try again.",
                type: "error"
              });
            });
        }
      });
    },

    showForm(fleetIndex = null) {
      this.editingFleet = this.fleets[fleetIndex];
      this.formShowing = true;
    },

    hideForm() {
      this.formShowing = false;
    },

    formSubmitted(response) {
      this.hideForm();

      this.deletingFleet = null;

      this.loadFleets();

      this.$swal({
        title: "Success!",
        text: this.successMessage,
        type: "success"
      });

      this.editingFleet = null;
    },

    createError() {
      this.hideForm();

      this.$swal({
        title: "Error!",
        text: "Please try again.",
        type: "error"
      });

      this.editingFleet = null;
    }
  },

  computed: {
    successMessage() {
      if (this.editingFleet) {
        return "Fleet updated.";
      }

      return "Fleet created.";
    }
  }
};
</script>
